import { Record } from 'immutable';

const RatePlanCodeReservationCountsRecord = Record({
  eventId: null,
  ratePlanCode: null,
  reservationCount: null
});

export class RatePlanCodeReservationCounts extends RatePlanCodeReservationCountsRecord {
  eventId: number;
  ratePlanCode: string;
  reservationCount: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code-reservation-counts.ts